import { devOrProd } from '@/utils'
import { ref } from '@vue/composition-api'
import { useApiPlus } from './use_api'

export function useShareParams(id: string, noUrl = false) {
  const params = ref({
    title: '',
    desc: '',
    cover: '',
    url: '',
  })

  if (id) {
    useApiPlus(
      {
        shareData: async () =>
          fetch(
            `https://h5p-gw.${devOrProd(
              'duotest',
              'gogpay',
            )}.cn/basicPageConfig/api/getAppLinkDetail`,
            {
              method: 'POST',
              body: JSON.stringify({
                appLinkId: id,
              }),
              headers: {
                'Content-Type': 'application/json',
              },
            },
          )
            .then(res => res.json())
            .then(res => res.data),
      },
      {
        onChange: ({ data }) => {
          params.value = {
            title: data.shareData.shareTitle,
            desc: data.shareData.shareContent,
            cover: data.shareData.shareImgUrl,
            url: noUrl
              ? ''
              : `https://h5.gogpay.cn/${devOrProd(
                  'h5-test',
                  'h5',
                )}/dcb-third-open/index.html#/home?appLinkId=${id}`,
          }
        },
      },
    )
  }

  return params
}
